module.exports = __webpack_public_path__ + "static/media/composite.657c0cb9.png";